/* eslint-disable */
import React, { useEffect } from 'react';
import { Create, useStore } from 'react-admin';
import CourseInstanceInputs from './CourseInstanceInputs';

const CourseInstanceCreate = (props) => {
    const [courseInstanceCreateParam, setCourseInstanceCreateParam] = useStore(
        'CourseInstance.createParams'
    );
    const defaultValues = {...courseInstanceCreateParam};
    useEffect(() => {
        return () => {
            setCourseInstanceCreateParam({})
        }
    })
    return (
        <Create {...props} redirect="edit">
            <CourseInstanceInputs isCreate={true} 
                {...props}
                defaultValues={defaultValues}
            />
        </Create>
    );
};

export default CourseInstanceCreate;
